type AnyObject = Record<string, any>;

export function deepCopy<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}

const createPickQuestionJSON = (n: AnyObject) => {
  let newObj: AnyObject = deepCopy(n);

  if (newObj["date"]) {
    newObj = handleDate(newObj);
  }

  newObj = handleLanguage(newObj);
  newObj = handleBuckets(newObj);

  const ret: string[] = [];

  for (const key in newObj) {
    if (Object.prototype.hasOwnProperty.call(newObj, key)) {
      if (newObj[key] != null && newObj[key] !== "") {
        ret.push(
          encodeURIComponent(key) +
            "=" +
            encodeURIComponent(String(newObj[key]))
        );
      }
    }
  }

  return { newObj, ret };
};

const handleLanguage = (newObj: AnyObject): AnyObject => {
  if (newObj["questionText"]) {
    newObj["languageSelected"] = "en";
  }
  return newObj;
};

const handleBuckets = (newObj: AnyObject): AnyObject => {
  const bucketString = localStorage.getItem("bucket");
  if (!newObj["buckets"]) {
    newObj["buckets"] = bucketString;
  }
  return newObj;
};

const handleDate = (newObj: AnyObject): AnyObject => {
  const [startDate, endDate] = newObj["date"] as any;

  newObj["startDate"] = startDate.split("T")[0];
  newObj["endDate"] = endDate.split("T")[0];

  delete newObj["date"];
  return newObj;
};

export { createPickQuestionJSON };
